import { money } from "@/lib/pathways";

export function Verdict({ verdict, timing }) {
  if (!verdict) return null;
  return (
    <div data-testid="verdict-box" className="relative border-2 border-[#E63946] bg-[#141417] p-8 md:p-10">
      <div className="absolute -top-3 left-6 bg-[#0C0C0E] px-3">
        <span className="font-label text-xs tracking-[0.3em] text-[#E63946]">VERDICT</span>
      </div>
      <div className="flex flex-wrap items-center gap-4 mb-4">
        <span className="font-label text-xs tracking-widest bg-[#E63946] text-white px-3 py-1">{verdict.decision}</span>
        {timing && timing.signal && timing.signal !== "N/A" && (
          <span className="font-label text-xs tracking-widest text-[#D4AF37] border border-[#D4AF37] px-3 py-1">
            TIMING: {timing.signal}
          </span>
        )}
      </div>
      <p className="font-display text-2xl md:text-4xl leading-tight redpen-underline inline">{verdict.quote}</p>
      {verdict.reasoning && <p className="text-sm text-stone-400 mt-5 max-w-2xl leading-relaxed">{verdict.reasoning}</p>}
      {timing?.why && <p className="text-xs text-stone-500 mt-3 font-label">TIMING · {timing.why}</p>}
    </div>
  );
}

export function SavingsBox({ savings }) {
  if (!savings) return null;
  const isMonthly = savings.billing === "monthly";
  const rows = [
    { label: "CURRENT COST", value: money(savings.current_cost) + (isMonthly ? "/mo" : ""), color: "#71717a", strike: true },
    { label: "LOWER-COST ROUTE", value: money(savings.alternative_cost) + (isMonthly ? "/mo" : ""), color: "#F5F2EB" },
    { label: "POTENTIAL SAVINGS", value: money(savings.potential_savings) + (isMonthly ? "/mo" : ""), color: "#5FB878" },
    { label: "ANNUALIZED", value: money(savings.annualized_savings) + "/yr", color: "#D4AF37" },
  ];
  return (
    <div data-testid="savings-box" className="border hairline bg-[#141417]">
      <div className="px-6 py-4 border-b hairline">
        <span className="eyebrow">THE MATH · POTENTIAL, NOT GUARANTEED</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-y md:divide-y-0 divide-white/10">
        {rows.map((r) => (
          <div key={r.label} className="p-6">
            <div className="font-label text-[10px] tracking-widest text-stone-500 mb-2">{r.label}</div>
            <div className={`font-display text-3xl leading-none ${r.strike ? "strike" : ""}`} style={{ color: r.color }}>
              {r.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
